import {
  readExclusiveLoginRecord,
  removeExclusiveLoginRecord,
  writeExclusiveLoginRecord,
} from "./exclusiveLoginStorage";

/**
 * 로그인 세션의 출처 기록 — 파트너 SSO 로 시작된 세션인지 (design D7 step 6).
 *
 * 파트너 SSO 사용자는 비밀번호를 알 수 없다(백엔드가 발급할 때마다 바꾼다). 그래서 그 세션이 밀려나면 비밀번호
 * 재로그인이 아니라 파트너 포털(하이보드)에서 다시 접속하라고 안내해야 한다.
 *
 * - SSO 콜백의 점유가 진행으로 끝나면 기록한다.
 * - 비밀번호 로그인의 점유가 진행으로 끝나거나 명시적으로 로그아웃하면 지운다.
 * - Cognito 세션 키와 별개 키라서 `clearCognitoSessionStorage()`·로컬 로그아웃 뒤에도 남는다. 밀려남 처리기는
 *   로그아웃 뒤에도 사유를 고를 수 있고, 다른 탭도 같은 기록을 읽어 같은 사유를 쓴다.
 */
const LOGIN_SESSION_SOURCE_KEY = "exclusiveLogin.sessionSource";
const PARTNER_SSO_SESSION_SOURCE = "partner-sso";

export function markPartnerSsoSession(): void {
  writeExclusiveLoginRecord(LOGIN_SESSION_SOURCE_KEY, PARTNER_SSO_SESSION_SOURCE);
}

export function clearLoginSessionSource(): void {
  removeExclusiveLoginRecord(LOGIN_SESSION_SOURCE_KEY);
}

export function isPartnerSsoSession(): boolean {
  return readExclusiveLoginRecord(LOGIN_SESSION_SOURCE_KEY) === PARTNER_SSO_SESSION_SOURCE;
}
